const navValues = [
	{
		label: "Marketing",
		selectedText: "",
		items: [
			{
				showArrow: false,
				name: "One Time Text Campaign",
				toRoute: "/one-time-text"
			},
			{
				showArrow: false,
				name: "Auto Campaigns",
				toRoute: "/auto-campaigns"
			}
		]
	},
	{
		label: "Navigation",
		selectedText: "",
		items: [
			{
				name: "Companies",
				showArrow: false,
				toRoute: "/companies"
			},
			{
				name: "Locations",
				showArrow: false,
				toRoute: "/locations"
			},
			{
				name: "Business Intelligence",
				showArrow: false,
				toRoute: "/business-intelligence"
			},
			{
				showArrow: false,
				name: "Members",
				toRoute: "/members"
			},
			{
				showArrow: false,
				name: "Loyalty Plan",
				toRoute: "/plans"
			},
			{
				name: "Surveys",
				showArrow: false,
				toRoute: "/surveys"
			},
			{
				showArrow: false,
				name: "Users",
				toRoute: "/users"
			},
			{
				showArrow: false,
				name: "Cashiers",
				toRoute: "/cashiers"
			},
			{
				showArrow: false,
				name: "Help",
				toRoute: "/help"
			},
		]
	}
]

export default navValues;



/** WEBPACK FOOTER **
 ** ./src/helpers/NavigationValues.js
 **/